import { RefObject, useEffect } from 'react';

const useOutsideClick = (ref: RefObject<HTMLElement>, callback) => {
  useEffect(() => {
    const handleClick = event => {
      if (ref?.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    if (ref) {
      document.addEventListener('click', handleClick);
    }

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref]);

  return ref;
};

export default useOutsideClick;
